export function isLink(f) {
    return 'link_type' in f && 'primary_key' in f;
}

//# sourceMappingURL=Link.js.map